import React from 'react';
import FontAwesomeIcon from '../Icon';
import moment from 'moment';
import { useSelector } from 'react-redux';
import InboxEmpty from './InboxEmpty';

const InboxMessagesList = ({
    onSelectItem,
    selectedId,
    loader
}) => {
  const inboxList = useSelector(state => state.inbox?.inboxList || []);
  const user = useSelector(state => state.auth?.user || {});
  
    return (
      inboxList && inboxList.length > 0 ?
      inboxList.map((item, i) => {    
            return (
              <div className={item.referenceId === selectedId ? 'selected_messagesUsersList' : 'messagesUsersList'} key={i} onClick={() => onSelectItem(item)}>
               {/* 
                  Modified By: Sai Prasad
                  Modified Date: 23/08/2022 1:15 PM
                  Jira Ticket: JUN-3149
                  Description: updated the inbox profile icons 
               */}
                <div className='userIcon'> 
                  <FontAwesomeIcon
                      glyph={item.referenceType === "Ticket" ? "wrench" : "building"}
                      weight="light"
                      size="custom"
                  />
                </div>
                 {/* 
                  Modified By: Sai Prasad
                  Modified Date: 20/10/2022
                  Jira Ticket: JUN-3308
                  Description: display property, unit for both service request and suite messages.
               */}
                <div className='userInfo'>
                  <div className='userInfo__timeStamp'>{
                   item.receivedOn && moment(item.receivedOn).format('MM/DD/YYYY')}</div>
                   {item.sentBy !== user.id && item.isRead === false && <div className='unreadd_dot' />}
                  <div className='userInfo__UserName'>{item.propertyName}</div>
                  <div className='userInfo__UserSuiteName'>{item.suiteName}</div>
                 {item.referenceType === "Ticket" && <div className='userInfo__UserDescription'>{item.description} </div>}
                </div>
              </div>
            )
          })
          : !loader && <InboxEmpty message={'Your inbox is empty.'}/>
    )
}

export default InboxMessagesList;